import { ReactElement, PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./AppStoreLayout.module.less";

export type AppStoreLayoutProps = {
	fillHeight?: boolean;
};

export const AppStoreLayout = (props: PropsWithChildren<AppStoreLayoutProps>): ReactElement => {
	const {
		children,
		fillHeight = false
	} = props;

	return (
		<div
			className={classNames(
				{
					[styles.root_fillHeight]: fillHeight
				}
			)}
		>
			{children}
		</div>
	);
};
AppStoreLayout.displayName = "AppStoreLayout";

export type AppStoreLayoutHeaderProps = {
	actions?: ReactElement;
	search?: ReactElement;
};

export const AppStoreLayoutHeader = (props: AppStoreLayoutHeaderProps): ReactElement => {
	const {
		actions,
		search
	} = props;

	return (
		<div className={styles.header}>
			{actions && (
				<div className={styles.viewSelection}>
					{actions}
				</div>
			)}

			{search && (
				<div className={styles.search}>
					{search}
				</div>
			)}
		</div>
	);
};
AppStoreLayoutHeader.displayName = "AppStoreLayout.Header";

export type AppStoreLayoutCategoryNameProps = {
	name: string;
};

export const AppStoreLayoutCategoryName = (props: AppStoreLayoutCategoryNameProps): ReactElement => {
	const { name } = props;

	return (
		<h3 className={styles.categoryName}>
			{name}
		</h3>
	);
};
AppStoreLayoutCategoryName.displayName = "AppStoreLayout.CategoryName";

AppStoreLayout.Header = AppStoreLayoutHeader;
AppStoreLayout.CategoryName = AppStoreLayoutCategoryName;
